import React, { useState, useEffect, useRef, useCallback } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { db } from '../../';
import { ref, onValue, push, remove, update, get } from 'firebase/database';
import { getStorage, ref as storageRef, getDownloadURL } from 'firebase/storage';
import Loading from '../components/Loading';
import AddressLabel from '../components/AddressLabel';
import BottomMenu from './components/BottomMenu';
import MissionSubmitStatus from './MissionSubmitStatus';

const MissionReport = () => {
    const location = useLocation();
    const { gameId, teamId, missionId } = location.state;
    const [mission, setMission] = useState({});
    const [loading, setLoading] = useState(true);
    // const [comment, setComment] = useState('');
    const [teamData, setTeamData] = useState({});
    const navigate = useNavigate();
    const [image, setImage] = useState([]);
    const storage = getStorage();
    const [leftTime, setLeftTime] = useState(null);
    const timer = useRef(null);
    const [teams, setTeams] = useState([]);


    // 残り時間の計算
    const calcTimeLeft = useCallback((time) => {
        const now = new Date().getTime();
        const endTime = new Date(time).getTime();
        const timeLeft = endTime - now;

        if(timeLeft < 0) {
            return "終了済み";
        }

        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
    }, []);

    // タイマーの設定
    const setCalcTime = useCallback(async (deadline) => {
        if(new Date(deadline).getTime() < new Date().getTime()) {
            await clearInterval(timer.current);
            setLeftTime("終了済み");
            return;
        } else {
            await clearInterval(timer.current);
            timer.current = setInterval(() => {
                setLeftTime(calcTimeLeft(deadline));
            }, 1000);
        }
    }, [calcTimeLeft]);

    useEffect(() => {
        // タイマーのクリア
        if(timer.current) clearInterval(timer.current);
        timer.current = null;

        // ミッション情報の取得
        const missionRef = ref(db, 'gameLogs/' + gameId + '/missions/' + missionId);

        const unsubscribeMission = onValue(missionRef, (snapshot) => {
            if(snapshot.exists()) {
                setMission(snapshot.val());

                // 残り時間の計算
                setCalcTime(snapshot.val().deadline);
            }
            setLoading(false);
        });

        //チームデータの取得
        const teamRef = ref(db, 'gameLogs/' + gameId + '/teams/' + teamId);
        const unsubscribeTeam = onValue(teamRef, (snapshot) => {
            if(snapshot.exists()) {
                setTeamData(snapshot.val());
            }
        });

        // 全チームデータの取得
        const teamsRef = ref(db, 'gameLogs/' + gameId + '/teams/');
        get(teamsRef)
        .then((snapshot) => {
            if(snapshot.exists()) {
                const teamsData = snapshot.val();
                const teamsArray = Object.keys(teamsData).map((key) => ({
                    id: key,
                    ...teamsData[key]
                }));
                setTeams(teamsArray);
            }
        });

        return () => {
            unsubscribeMission();
            unsubscribeTeam();
        };
    }, [gameId, missionId, teamId, setCalcTime]);

    // 自チームのレポートに写真があれば表示
    useEffect(() => {
        if(mission.reports && mission.reports[teamId] && mission.reports[teamId].photo) {
            setImage([]);

            mission.reports[teamId].photo.forEach((photo) => {
                getDownloadURL(storageRef(storage, 'gameLogs/' + gameId + '/missions/' + missionId + '/reports/' + teamId + '/' + photo))
                .then((url) => {
                    setImage((prev) => [...prev, url]);
                });
            })
        }
    }, [mission, gameId, missionId, teamId, storage]);

    // レポートの削除
    const deleteReport = () => {
        if(window.confirm('提出を削除しますか？')) {
            const reportRef = ref(db, 'gameLogs/' + gameId + '/missions/' + missionId + '/reports/' + teamId);
            remove(reportRef)
            .then(() => {
                //スコアを減点
                const teamRef = ref(db, 'gameLogs/' + gameId + '/teams/' + teamId);
                update(teamRef, {
                    score: teamData.score - mission.score
                })
                .then(() => {
                    // ログに記録
                    const logRef = ref(db, 'gameLogs/' + gameId + '/history/');
                    push(logRef, {
                        actionNum: 10,
                        action: 'ミッションの提出を削除',
                        teamId: teamId,
                        team: teamData,
                        missionId: missionId,
                        missionTitle: mission.name,
                        time: new Date().toISOString()
                    })
                    .then(() => {
                        alert('提出を削除しました');
                        navigate('/game/missions', { state: { gameId: gameId, teamId: teamId } });
                    })
                    .catch((error) => {
                        console.error('削除履歴の記録に失敗しました:', error);
                        alert('提出は削除されましたが、履歴の記録に失敗しました。');
                        navigate('/game/missions', { state: { gameId: gameId, teamId: teamId } });
                    });
                })
                .catch((error) => {
                    console.error('スコアの更新に失敗しました:', error);
                    alert('提出は削除されましたが、スコアの更新に失敗しました。ゲーム運営者にお問い合わせください。');
                });
            })
            .catch((error) => {
                console.error('提出の削除に失敗しました:', error);
                alert('提出の削除に失敗しました。もう一度お試しください。');
            });
        }
    }


  return (
    <div className='max-w-6xl mx-auto my-6'>
        <Loading show={loading} text="ミッションを読込み中…" />

        <h1 className='text-2xl mb-6 mx-4 text-center'>ミッション</h1>

        <div className='lg:grid lg:grid-cols-2'>
            {/* ミッション情報 */}
            <div className='rounded-lg border bg-white p-4 m-3 mb-6'>
                <h2 className='text-lg mb-2 text-purple-600'>ミッション情報</h2>

                <div className='mb-5 ms-3'>
                    <h3 className='text-xl border-b-8 border-lime-300/50 inline px-2 text-gray-800'>{mission && mission.name}</h3>
                </div>

                <div className='mb-8 ms-3'>
                    <h3 className='text-base text-gray-600 whitespace-pre-wrap'>{mission && mission.detail}</h3>
                </div>

                {/* ミッション画像 */}
                {mission && mission.image && (
                    <div className='mb-5 mx-3'>
                        <img src={mission.image} alt="ミッション画像" className='rounded-lg shadow-md max-w-full' />
                    </div>
                )}

                <div className='mb-3 ms-3 grid grid-cols-2 gap-5'>
                    <div>
                        <h4 className='text-base text-gray-600'><i className='bi bi-coin me-1 text-lime-600'></i>報酬スコア</h4>
                        <div className='text-xl text-gray-800 ms-2'>{mission && mission.score} pt</div>
                    </div>

                    <div>
                        <h4 className='text-base text-gray-600'><i className='bi bi-x-lg me-1 text-lime-600'></i>未達成時の減点</h4>
                        <div className='text-xl text-gray-800 ms-2'>{mission && (mission.penalty ? mission.penalty : 0)} pt</div>
                    </div>

                    <div>
                        <h4 className='text-base text-gray-600 mb-1'><i className='bi bi-key me-1 text-lime-600'></i>提出権限</h4>
                        <div className='text-base text-gray-800 ms-2'>{mission.options && (!mission.options[0] && '🏃‍♂️‍➡️逃走 ')}{mission.options && (!mission.options[1] && '👹鬼')}</div>
                    </div>

                    <div>
                        <h4 className='text-base text-gray-600'><i className='bi bi-clock me-1 text-lime-600'></i>残り時間</h4>
                        <div className='text-2xl text-gray-800 ms-2 play-regular'>{leftTime !== null ? leftTime : "--:--:--"}</div>
                        <div className='text-base text-lime-700 ms-2 play-regular'>{mission && new Date(mission.deadline).toLocaleTimeString()} まで</div>
                    </div>
                </div>
            </div>

            {/* 提出レポート */}
            <div className='rounded-lg border bg-white p-4 m-3 mb-6'>
                <h2 className='text-lg mb-2 text-purple-600'><i className='bi bi-upload me-2'></i>レポート</h2>

                <label className='block mb-6'>
                    <span className='text-gray-600'>位置情報</span>
                    <div className='relative rounded-lg border border-gray-300 min-h-20 p-2'>
                        {mission.reports && mission.reports[teamId] && mission.reports[teamId].position && (
                            <div className='relative'>
                                <p className='pe-20'>
                                    <AddressLabel lat={mission.reports[teamId].position.lat} lng={mission.reports[teamId].position.lng} /><br/>
                                    精度 : {Math.floor(mission.reports[teamId].position.accuracy * 10) / 10} m
                                </p>

                                <Link to={"https://www.google.com/maps/search/?api=1&query="+mission.reports[teamId].position.lat+","+mission.reports[teamId].position.lng} className='block text-center absolute top-1 end-2 bg-purple-500 hover:bg-purple-600 text-white p-1 px-2 rounded-md text-sm'>
                                    <div>
                                        <i className='bi bi-google text-lg'></i>
                                    </div>
                                    地図で確認
                                </Link>
                            </div>
                        )}
                    </div>
                    
                </label>

                <label className='block mb-6'>
                    <span className='text-gray-600'>写真</span>
                    <div className='grid grid-cols-2'>
                    {
                        image.length > 0 ? image.map((url, index) => (
                            <div key={index} className='relative rounded-lg m-2'>
                                <img src={url} alt={'photo'+index} className='rounded-md border' />
                            </div>
                        )) : (
                            <p className='text-gray-400'>写真なし</p>
                        )
                    }
                    </div>
                    
                </label>

                <label className='block mb-6'>
                    <span className='text-gray-600'>コメント</span>
                    <div className='relative rounded-lg border border-gray-300 p-2'>
                        {(mission.reports && mission.reports[teamId] && mission.reports[teamId].comment) ? (
                            <p className='whitespace-pre-wrap'>{mission.reports[teamId].comment}</p>
                        ) : (
                            <p className='text-gray-400'>コメントなし</p>
                        )}
                    </div>
                </label>

                {/* 提出を削除 */}
                {
                    mission.reports && mission.reports[teamId] ? (
                        <div className='text-center'>
                            <button className='bg-red-500 hover:bg-red-600 text-white p-2 px-6 rounded-md' onClick={() => {deleteReport()}}>
                                <i className='bi bi-trash3 me-2'></i>提出を削除
                            </button>
                        </div>
                    ) : (
                        <div className='text-center text-red-700 mb-4'>
                            提出していません
                        </div>
                    )
                }
                
            </div>

            {/* 提出状況 */}
            <MissionSubmitStatus mission={mission} teams={teams} />
        </div>

        {/* 下部固定メニュー */}
        <BottomMenu gameId={gameId} teamId={teamId} />
    </div>
  )
}

export default MissionReport